import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

export default class BN_Asam4AssessmentMeasure extends BackboneElement {
    static __className = 'BN_Asam4AssessmentMeasure';

    __objectStructure = {
        measureName: String,
        measureScore: Number,
        measureDateTime: String,
    };

    constructor(constructJson, className = 'BN_Asam4AssessmentMeasure') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
